import { RootNode } from './PivotNode';
import { ResultSet } from './ResultSet';
export class PivotResult {
    constructor(query) {
        this._root = new RootNode();
        this._base = new ResultSet();
        this._layers = new Map();
        for (const [channel, layers] of Array.from(query.layers)) {
            for (const layer of layers) {
                this.layers.set(layer.name, new ResultSet());
            }
        }
    }
    get query() {
        return this._query;
    }
    get root() {
        return this._root;
    }
    get base() {
        return this._base;
    }
    get layers() {
        return this._layers;
    }
    getResultSet(alias) {
        if (alias == null) {
            return this.base;
        }
        else {
            return this.layers.get(alias);
        }
    }
    addBaseRow(row) {
        this.base.add(row);
    }
    addLayerRow(alias, row) {
        this.layers.get(alias).add(row);
    }
}
